module.exports = __webpack_public_path__ + "static/media/sf_6.a68bb23a.svg";